import DeleteSvg from '../assets/img/svg/delete'
import selectStyle from '../const/select'
import SelectField from '../ui/select-field'

const ModalLineColumn = (props) => {
  const {
    option,
    optionValue,
    deleteCallback,
    action,
    actionValue,
    optCallback,
    actCallback,
    optOption,
    // trigger,
    // triggerVal,
    // action,
    // actionVal,
    // optTrigger,
    // optAction,
    // valueCallback,
    // valueActCallback,
    ...rest
  } = props

  // const styleTrgSelect = trigger === 'field_by_id' ? '-id' : ''
  // const styleActSelect = action === 'field_by_id' ? '-id' : ''
  // const checkSelect = trigger === 'field_by_id'
  // const checkActSelect = action === 'field_by_id'

  return (
    <div className="modal-column-line-column" {...rest}>
      <div className="modal-column-line-column-item">
        <DeleteSvg
          className="modal-column-line-column-close"
          onClick={deleteCallback}
        />
        <div className={`modal-column-line-column-select`}>
          <SelectField
            value={option}
            callback={optCallback}
            style={selectStyle}
            opt={optOption}
          />
        </div>
      </div>
      <div />
      <div className="modal-column-line-column-item">
        <div className={`modal-column-line-column-select`}>
          <SelectField
            value={action}
            callback={actCallback}
            style={selectStyle}
            opt={[]}
          />
        </div>
      </div>
    </div>
  )
}

export default ModalLineColumn
